/*************************************************************************
 * Copyright 2022 VMware, Inc.  All rights reserved. VMware Confidential
 * *************************************************************************/

export enum HttpStatusCodes {
  OK = 200,
  UNAUTHORIZED = 401
}
